import React, { useEffect } from 'react'

import { useScrollableParent } from '@avantstay/avantstay-ui/lib/utils/useScrollableParent'

export function useScrollBy(
  ref: React.Ref<HTMLElement>,
  shouldScrollToElement?: boolean,
  getCustomTopPosition?: (elOffset: number) => number,
): void {
  const scrollableParent = useScrollableParent((ref as React.MutableRefObject<HTMLElement>).current)

  useEffect(() => {
    if (ref !== null && shouldScrollToElement) {
      if (scrollableParent) {
        scrollableParent.scrollTo({
          top: getCustomTopPosition
            ? getCustomTopPosition((ref as React.MutableRefObject<HTMLElement>).current.offsetTop)
            : (ref as React.MutableRefObject<HTMLElement>).current.offsetTop,
          left: 0,
          behavior: 'smooth',
        })
      }
    }
  }, [ref, shouldScrollToElement, scrollableParent, getCustomTopPosition])
}
